// Data obowiązywania i wersja dokumentów prawnych. Teksty w i18nexus mają szablony
// („[DATA]”, „[xx.xx.xxxx]”, „[X.Y]”) — podstawiamy tu wartości, dopóki w i18nexus
// nie zostaną wpisane właściwe (wtedy zamiana nic nie zmienia).
export const LEGAL_EFFECTIVE_DATE = '30.01.2026';
export const LEGAL_VERSION = '1.0';

// Dokumenty zmienione później mają własną datę i wersję
export const LEGAL_DOCS = {
    privacypolicy: { date: '30.09.2026', version: '1.1' },
    cookies: { date: '30.09.2026', version: '1.1' },
};

export const fillLegalDate = (text, doc, archivedVersion) => {
    if (typeof text !== 'string') return text;
    const archived = archivedVersion && LEGAL_HISTORY[doc]?.versions.find(v => v.version === archivedVersion);
    const meta = archived ? { date: archived.from, version: archived.version }
        : (doc && LEGAL_DOCS[doc]) || { date: LEGAL_EFFECTIVE_DATE, version: LEGAL_VERSION };
    return text
        .replace(/\[(DATA|DATE|xx\.xx\.xxxx|dd\.mm\.yyyy)\]/i, meta.date)
        .replace(/\[X\.Y\]/i, meta.version);
};

// Historia wersji dokumentów (archiwum). Pierwsza pozycja = wersja obowiązująca.
export const LEGAL_HISTORY = {
    regulations: {
        titlePl: 'Regulamin platformy', titleEn: 'Platform Terms',
        versions: [{ version: '1.0', from: '30.01.2026', path: '/regulations' }],
    },
    privacypolicy: {
        titlePl: 'Polityka prywatności', titleEn: 'Privacy Policy',
        versions: [
            { version: '1.1', from: '30.09.2026', path: '/privacy-policy' },
            { version: '1.0', from: '30.01.2026', to: '29.09.2026', path: '/privacy-policy/v1.0' },
        ],
    },
    cookies: {
        titlePl: 'Polityka plików cookie', titleEn: 'Cookie Policy',
        versions: [
            { version: '1.1', from: '30.09.2026', path: '/cookie' },
            { version: '1.0', from: '30.01.2026', to: '29.09.2026', path: '/cookie/v1.0' },
        ],
    },
    'data-processing': {
        titlePl: 'Umowa powierzenia przetwarzania danych (DPA)', titleEn: 'Data Processing Agreement (DPA)',
        versions: [{ version: '1.0', from: '30.01.2026', path: '/data-processing' }],
    },
    'price-list': {
        titlePl: 'Cennik', titleEn: 'Price list',
        versions: [{ version: '1.0', from: '30.01.2026', path: '/price-list' }],
    },
};

// Wersja archiwalna: nadpisuje datę i wersję w nagłówku dokumentu
export const archivedMeta = (doc, version) =>
    LEGAL_HISTORY[doc]?.versions.find(v => v.version === version);
